import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faDollarSign, faMobileAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from './ThemeContext'; 
import { use } from 'react';
const { useAuth } = require('./AuthContext'); 

const IronsideLanding = () => {
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isNavOpen, setIsNavOpen] = useState(false);
  const { loginWithEmail } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const loginTimeout = setTimeout(() => {
      setIsLoading(false);
      setError('Login process is taking too long. Please try again.');
    }, 15000);

    try {
      await loginWithEmail(email, password);
      clearTimeout(loginTimeout);
    } catch (err) {
      console.error("Error Logging In:", err);
      setError(err.message);
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#e0e0e0] to-[#5f308c] text-[var(--primary-text)] shadow-md">
  <div className="container mx-auto px-6 py-4 flex justify-between items-center">
    <div className="flex justify-center w-full md:w-auto">
      <img src={theme.logo} alt="Ironside Industrial Logo" className="w-48 md:w-64 h-auto" />
    </div>
    <nav className="hidden md:flex space-x-6">
      <Link to="/discounts" className="hover:text-gray-300 transition text-white">Explore Discounts</Link>
      <a href="#contact" className="hover:text-gray-300 transition text-white">Contact</a>
      <Link to="/registration" className="hover:text-gray-300 transition text-white">Sign Up</Link>
    </nav>
    <button className="md:hidden text-white" onClick={() => setIsNavOpen(!isNavOpen)}>
      <FontAwesomeIcon icon={faBars} className="text-2xl" />
    </button>
  </div>
  {isNavOpen && (
    <nav className="md:hidden bg-[#5f308c] px-6 py-4">
      <div className="space-y-4 text-center">
        <Link to="/discounts" className="block hover:text-gray-300 text-white" onClick={() => setIsNavOpen(false)}>Explore Discounts</Link>
        <a href="#contact" className="block hover:text-gray-300 text-white" onClick={() => setIsNavOpen(false)}>Contact</a>
        <Link to="/registration" className="block hover:text-gray-300 text-white" onClick={() => setIsNavOpen(false)}>Sign Up</Link>
      </div>
    </nav>
  )}
</header>

      {/* Hero Section with Fixed Background */}
      <section className="relative min-h-screen flex items-center justify-center">
        <div
          className="absolute inset-0 bg-fixed bg-cover bg-center"
          style={{ backgroundImage: `url('/images/oil-well-sunset.jpeg')` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40"></div>
        <div className="relative z-10 container mx-auto px-6 flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0 md:space-x-8">
          {/* Login Form */}
          <div className="w-full md:w-1/2 bg-white rounded-xl p-8 shadow-lg">
            <h2 className="text-3xl font-bold text-[var(--primary-color)] mb-6">Login</h2>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-gray-700 mb-1">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                />
              </div>
              <div>
                <label htmlFor="password" className="block text-gray-700 mb-1">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[var(--primary-color)] to-[#7e4ca8] text-white font-bold py-3 rounded-md hover:from-[#7e4ca8] hover:to-[var(--primary-color)] transition-all"
              >
                Login
              </button>
            </form>
            <p className="text-center mt-4">
              New here?{' '}
              <Link to="/registration" className="text-[var(--primary-color)] hover:underline">Sign Up</Link>
            </p>
            <p className="text-center">
              <Link to="/resetpassword" className="text-[var(--primary-color)] hover:underline">Forgot Password?</Link>
            </p>
          </div>

          {/* Benefits Pitch */}
          <div className="w-full md:w-1/2 text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Power Your Fleet with Ironside</h1>
            <p className="text-xl mb-6">Save time and money with our fuel program designed for fleet managers.</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Save $0.40/gallon at 4,000+ locations</li>
              <li>Nationwide fueling network</li>
              <li>Mobile card management</li>
              <li>Instant funds, no credit checks</li>
            </ul>
            <Link
              to="/registration"
              className="mt-6 inline-block bg-gradient-to-r from-[var(--primary-color)] to-[#7e4ca8] text-white font-bold py-3 px-6 rounded-md hover:from-[#7e4ca8] hover:to-[var(--primary-color)] transition-all"
            >
              Sign Up Now
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-[var(--primary-color)] mb-12">Why Ironside?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <FontAwesomeIcon icon={faDollarSign} className="text-[var(--primary-color)] text-4xl mb-4" />
            <h3 className="text-xl font-semibold text-[var(--primary-color)] mb-2">Cost Savings</h3>
            <p>Save an average of $0.40 per gallon at over 4,000 locations.</p>
          </div>
          <div className="text-center">
            <FontAwesomeIcon icon={faMobileAlt} className="text-[var(--primary-color)] text-4xl mb-4" />
            <h3 className="text-xl font-semibold text-[var(--primary-color)] mb-2">Convenience</h3>
            <p>Manage fuel cards from anywhere with our mobile platform.</p>
          </div>
          <div className="text-center">
            <FontAwesomeIcon icon={faMapMarkedAlt} className="text-[var(--primary-color)] text-4xl mb-4" />
            <h3 className="text-xl font-semibold text-[var(--primary-color)] mb-2">Nationwide Coverage</h3>
            <p>Access fueling stations across the country.</p>
          </div>
        </div>
      </div>
    </section>

      {/* Partners Section */}
      <section className="py-16 bg-gradient-to-b from-white to-gray-100">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-[var(--primary-color)] mb-12">Our Network Partners</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/ta-tri-logo-primary.svg" alt="TA Petro" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/speedwayLogo.svg" alt="Speedway" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/racetracLogo.png" alt="RaceTrac" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/roadRangerLogo.png" alt="Road Ranger" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/quarlesLogo.svg" alt="Quarles" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/caseysLogo.svg" alt="Casey's" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/sappBrosLogo.png" alt="Sapp Bros" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/maverikLogo.svg" alt="Maverik" className="h-16 object-contain" />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-lg shadow-md">
            <img src="/logos/ambest-logo.png" alt="AM Best" className="h-16 object-contain" />
          </div>
        </div>
      </div>
    </section>

      {/* Footer */}
      <footer className="bg-[var(--primary-color)] text-white py-6">
        <div className="container mx-auto px-6 text-center">
          <p>&copy; {new Date().getFullYear()} Ironside Industrial. All rights reserved.</p>
          <p>
            <a href="/privacy" className="hover:underline">Privacy Policy</a> |{' '}
            <a href="/terms" className="hover:underline">Terms of Service</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default IronsideLanding;